// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-selection-list{
    display:flex;
}
.restaccordion {
    display: flex;
    flex-direction: column;
}
.restaccordion .mat-expanded {
    flex: 1 1 auto;
}
    
.restaccordion .mat-expansion-panel {
    display: flex;
    flex-direction: column;
}

.restaccordion .mat-expansion-panel-header {
    flex: unset !important;
}


`, "",{"version":3,"sources":["webpack://./src/app/settings/datamodel/containerrest/containerrest.detail.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":[".mat-selection-list{\n    display:flex;\n}\n.restaccordion {\n    display: flex;\n    flex-direction: column;\n}\n.restaccordion .mat-expanded {\n    flex: 1 1 auto;\n}\n    \n.restaccordion .mat-expansion-panel {\n    display: flex;\n    flex-direction: column;\n}\n\n.restaccordion .mat-expansion-panel-header {\n    flex: unset !important;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
